import React from "react";
import { EventCategory } from "../../../models/EventCategory";
import { EventSubtype } from "../../../models/EventSubtype";
import { EventType } from "../../../models/EventType";
import { Subheading } from "../../../design/heading";
import { Link } from "../../../design/link";
import { ChevronRightIcon } from "@heroicons/react/20/solid";
import EventTypeBadge from "../../../components/EventTypeBadge";
import EventSubtypeBadge from "../../../components/EventSubtypeBadge";
import { Text } from "../../../design/text";

interface EventCategoryListItemProps {
  eventCategory: EventCategory;
  eventTypes: EventType[];
  eventSubtypes: EventSubtype[];
}

const EventCategoryListItem: React.FC<EventCategoryListItemProps> = ({
  eventCategory,
  eventTypes,
  eventSubtypes,
}) => {
  const typesForCategory = eventTypes.filter(
    (type) => type.eventCategory === eventCategory._id,
  );

  return (
    <div className="mt-6 space-y-4">
      <Link
        href={`/event-category/${eventCategory._id}`}
        className="inline-flex items-center gap-2 text-zinc-900 dark:text-zinc-100 hover:underline"
      >
        <Subheading className="font-bold">{eventCategory.name}</Subheading>
        <ChevronRightIcon className="w-4 h-4 fill-zinc-400 dark:fill-zinc-500" />
      </Link>

      <div className="space-y-4">
        {typesForCategory.map((type) => {
          const relatedSubtypes = eventSubtypes.filter(
            (subtype) => subtype.eventType === type._id,
          );

          return (
            <div key={type._id} className="flex flex-col p-4 transition">
              <div className="flex flex-col items-start gap-4">
                <div className="shrink-0">
                  <EventTypeBadge
                    link
                    eventTypeId={type._id}
                    eventTypes={eventTypes}
                  />
                </div>

                <div className="flex flex-col gap-1">
                  {type.description && <Text>{type.description}</Text>}
                  {relatedSubtypes.map((subtype) => (
                    <div
                      key={subtype._id}
                      className="flex items-center gap-1 pl-8"
                    >
                      <EventSubtypeBadge
                        eventSubtypeId={subtype._id}
                        eventSubtypes={eventSubtypes}
                      />
                      <span className="text-xs text-zinc-500 dark:text-zinc-400">
                        {subtype.description}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default EventCategoryListItem;
